import { validators } from '../utils/validators';

/** Shared schema for log / edit time entry dialogs (TimeTracking page). */
export const timeEntrySchema = {
  client: [validators.required],
  hours: [validators.required, validators.minValue(0.25), validators.maxValue(24)],
  description: [validators.required, validators.minLength(3), validators.maxLength(500)],
  date: [validators.required],
};
